const screens = {
  landing: {
    pageType: 'landing screen',
    pageName: 'landing screen'
  },
  search: {
    pageType: 'search screen'
  },
  plp: {
    pageType: 'plp screen'
  },
  pdp: {
    pageType: 'pdp screen'
  },
  cart: {
    pageType: 'bag screen',
    pageName: 'bag screen'
  },
  wishlist: {
    pageType: 'closet screen',
    pageName: 'closet screen'
  },
  shipping: {
    pageType: 'shipping screen',
    pageName: 'shipping screen'
  },
  addressSelection: {
    pageType: 'address management screen'
  },
  manageAddress: {
    pageType: 'address management screen'
  },
  paymentFailed: {
    pageType: 'payment screen',
    pageName: 'payment failed screen'
  },
  paymentRetry: {
    pageType: 'payment screen',
    pageName: 'payment retry screen'
  },
  orderConfirmation: {
    pageType: 'thank you screen',
    pageName: 'order confirmation screen'
  },
  login_signup: {
    pageType: 'user account screen',
    pageName: 'login signup screen'
  },
  login_password: {
    pageType: 'user account screen',
    pageName: 'login password screen'
  },
  login_otp: {
    pageType: 'user account screen',
    pageName: 'login - otp screen'
  },
  signup: {
    pageType: 'user account screen',
    pageName: 'signup screen'
  },
  signup_otp: {
    pageType: 'user account screen',
    pageName: 'signup - otp screen'
  },
  social_mobilenumber: {
    pageType: 'user account screen'
  },
  social_otp: {
    pageType: 'user account screen'
  },
  otp_authentication: {
    pageType: 'user account screen',
    pageName: 'otp verify screens'
  },
  myAccountMain: {
    pageType: 'my account screen',
    pageName: 'my account screen'
  },
  orderList: {
    pageType: 'order management screen'
  },
  orderDetails: {
    pageType: 'order management screen',
    pageName: 'order details screen'
  },
  returnExchangeAddressSelection: {
    pageType: 'order management screen',
    pageName: 'return exchange address selection screen'
  },
  returnExchangeProductSelection: {
    pageType: 'order management screen',
    pageName: 'return exchange Product selection screen'
  },
  returnExchangeSelection: {
    pageType: 'order_management_screen',
    pageName: 'return exchange mode selection screen'
  },
  returnReasonSelection: {
    pageType: 'order management screen',
    pageName: 'return reason selection screen'
  },
  exchangeSizeReasonSelection: {
    pageType: 'order management screen',
    pageName: 'exchange size reason selection screen'
  },
  returnExchangePaymentModeSelection: {
    pageType: 'order management screen',
    pageName: 'return payment mode selection screen'
  },
  returnExchangeSuccess: {
    pageType: 'thank you screen'
  },
  storeLandingScreen_Trends_LUX: {
    pageType: 'landing screen'
  },
  myAccountAjioWalletOverview: {
    pageType: 'wallet screen',
    pageName: 'wallet overview screen'
  },
  myAccountAjioWalletPoints: {
    pageType: 'wallet screen',
    pageName: 'wallet points screen'
  },
  myAccountAjioWalletCash: {
    pageType: 'wallet screen',
    pageName: 'wallet cash screen'
  },
  myAccountAjioWalletHistoryScreen: {
    pageType: 'wallet screen',
    pageName: 'wallet transactions history screen'
  },
  myAccountMyRewards: {
    pageType: 'reward screen',
    pageName: 'rewards screen'
  },
  orderCancellationConfirm: {
    pageType: 'order  management screen',
    pageName: 'order cancellation screen '
  }
};
export default screens;
